"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _SecurityContextHolder = require("../api/SecurityContextHolder");
var _SocialLinks = _interopRequireDefault(require("../components/SocialLinks"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const curYear = new Date().getFullYear();
const getFooterLinks = footerItems => footerItems && footerItems.map(menuItem => /*#__PURE__*/_react.default.createElement("li", {
  key: menuItem.name
}, menuItem.path && menuItem.path.startsWith('http') ? /*#__PURE__*/_react.default.createElement("a", {
  href: menuItem.path,
  target: "_blank",
  rel: "noopener noreferrer"
}, menuItem.title) : /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
  to: menuItem.path,
  className: "navbar-item"
}, menuItem.title)));
const Footer = _ref => {
  let {
    footerItems,
    footerLinks,
    location
  } = _ref;
  const cssPathName = () => location !== null && location !== void 0 && location.pathname ? location.pathname.replace(/\W/g, '-') : '';
  const externalClassName = !_SecurityContextHolder.SecurityContextHolder.isAuthenticated() ? 'external' : '';
  return /*#__PURE__*/_react.default.createElement("footer", {
    className: `footer ${externalClassName} page-${cssPathName()}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "footer-additional",
    className: "container my-0 footer-additional"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "content has-text-centered has-text-white pt-6 pb-6"
  }, /*#__PURE__*/_react.default.createElement(_SocialLinks.default, null), /*#__PURE__*/_react.default.createElement("ul", {
    className: "footer-list"
  }, /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "copyright"
  }, "Copyright \xA9 ", curYear, " MissionSquare Retirement")), getFooterLinks(footerItems), footerLinks || /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.missionsq.org/about-us/policies-and-disclosures/missionsquare-retirement-policies/privacy-policy.html",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Privacy Policy")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.missionsq.org/about-us/policies-and-disclosures/missionsquare-retirement-policies/important-legal-information.html",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Important Legal Information")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.missionsq.org/about-us/policies-and-disclosures/missionsquare-retirement-policies/overview-of-disaster-recovery-and-business-continuity-plans.html",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Overview Of Disaster Recovery And Business Continuity Plans")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.missionsq.org/x3333.xml?RFID=W2542",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Form CRS")))))));
};
Footer.propTypes = {
  footerItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string.isRequired,
    path: _propTypes.default.string.isRequired,
    title: _propTypes.default.string.isRequired
  })),
  footerLinks: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object]),
  location: _propTypes.default.shape({
    pathname: _propTypes.default.string
  })
};
Footer.defaultProps = {
  footerItems: undefined,
  footerLinks: undefined
};
var _default = exports.default = (0, _reactRouterDom.withRouter)(Footer);
//# sourceMappingURL=Footer.js.map